/**
 * Internal app status event system for Shopify extension
 * Provides a centralized event emitter for internal application events
 */

import { EventEmitter } from "@redotech/util/event-emitter";

export interface RedoCheckoutButtonClickedEvent {
  type: "RedoCheckoutButtonClickedEvent";
  timestamp: number;
  addCoverage: boolean;
}

/**
 * Internal app status event emitter
 * Handles internal application events for the Redo Shopify extension
 * Extends the generic EventEmitter for type-safe event handling
 */
export class InternalAppStatusEmitter
  extends EventEmitter<globalThis.InternalAppEvent>
  implements globalThis.InternalAppStatusEmitter
{
  constructor() {
    super();
  }

  /**
   * Override error handler to provide custom logging if needed
   */
  protected override handleListenerError(
    error: Error,
    event: InternalAppEvent,
  ): void {
    console.error(`[Redo Internal Event Error] ${event.type}:`, error);
  }
}
